import { queryStrPageTo } from './urlQuery';

function funToApp(funName, opt,is_new) {
    var u = navigator.userAgent,
        app = navigator.appVersion;
    var data = null;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        if (window.android) {
            //console.log("安卓APP---" + funName, ...opt);
            data = window.android[funName] && window.android[funName](...opt);
        }
    } else if (isiOS) {
        
        if(is_new){
            console.log("new IOS---" + funName, [...opt]);
            //新版ios框架
            data = window.webkit && window.webkit.messageHandlers[funName].postMessage([...opt])
        }
        else{
            //旧版用这个方法
            console.log("old IOS---" + funName, [...opt]);
            data = window[funName] && window[funName](...opt);
        }
    }
    return data;
}



export default {
    // 前端调用客户端  根据类型和id跳转新页面
    igpJumpToNative: function (jump_tag, jump_tag_id,is_new) {
        funToApp('igpJumpToNative', [jump_tag, jump_tag_id],is_new);
    },
    // 前端调用客户端  分享
    igpJumpToNativeShare: function (share_message) {
        funToApp('igpJumpToNativeShare', arguments);
    },
    // 前端调用客户端  跳转到联系客服页面
    srGoToContact: function () {
        funToApp('srGoToContact', arguments);
    },
    isIphonXSeries: function () {
        if (window !== 'undefined' && window && !/iphone/gi.test(window.navigator.userAgent)) return false;
        const xSeriesConfig = [
            {  //iPhone Xs（Max,Pro Max）
                devicePixelRatio: 3,
                width: 414,
                height: 896,
            },
            {  // iPhone XR（11）
                devicePixelRatio: 2,
                width: 414,
                height: 896,
            },
            {  // iPhone X（Xs,Pro）
                devicePixelRatio: 3,
                width: 375,
                height: 812,
            },
        ];
        const {
            devicePixelRatio,
            screen: {
                width, height
            }
        } = window;
        return xSeriesConfig.some(item => item.devicePixelRatio === devicePixelRatio && item.width === width && item.height === height);
    },
    //前端调用客户端 name 方法名称 params 参数
    srH5CallNativeMethodApp: function(name,params) {
        let urlBase = '';
        if (process.env.NODE_PM === "prod") {
            urlBase = "https://mobile.aigupiao.com";
        } else if (process.env.NODE_PM === "dev") {
            urlBase = "https://mobiledev.aigupiao.com";
        } else if (process.env.NODE_PM === "test") {
            urlBase = "https://mobiletest.aigupiao.com";
        } else if (process.env.NODE_PM === "beta") {
            urlBase = "https://mobilebeta.aigupiao.com";
        } else {
            urlBase = "https://mobiledev.aigupiao.com";
        }

        let is_new = false;
        console.log('name',name,params)
        if(name == 'call_Native'){
            //默认都加前缀  加上传过来的公共参数
            if(params.url){
                if(params.url.indexOf("http") > -1) {

                } else {
                    params.url = urlBase + params.url;
                }
                
                if(params.url.includes('?')){
                    params.url += '&'+queryStrPageTo;
                }
                else{
                    params.url += '?'+queryStrPageTo;
                }
            }
            console.log('params',params)
        }
        if(name == 'call_native_photo' || ( name == 'call_Native' && params.kind == 'bind_phone')){
            
        }
        else{
            is_new = true;
        }

        

        let str = JSON.stringify({
            'method_name': name, 
            'params': params
        })
        funToApp('srH5CallNativeMethod', [str],is_new)
    },
    // 前端调用客户端  打开图片或视频 
    //直接在方法里转换成json，外面不用再写了
    srBrowserMedia: function (position, mediaUrlList) {
        //console.log(position, mediaUrlList)
        mediaUrlList = JSON.stringify(mediaUrlList)
        funToApp('srBrowserMedia', [position, mediaUrlList],true);
    },

    // 前端调用客户端  跳转到私信消息页面
    srGoToLetterMsg: function (id, circle_id) {
        funToApp('srGoToLetterMsg', arguments, true);
    },

    // 前端调用客户端  跳转中富签约页面
    srGoZFSign: function () {
        funToApp('srGoZFSign', arguments, true);
    },

};
